module.exports = __webpack_public_path__ + "img/3d_en.e5c0f55.jpg";